// extracted by mini-css-extract-plugin
export default {"cls1":"EmailLoginPage-cls1___f2dbce9a9cf92a3f6b9","cls2":"EmailLoginPage-cls2__fc45b57273d6bde03bac EmailLoginPage-cls1___f2dbce9a9cf92a3f6b9"};